import Persiana from './persiana';
export default Persiana;